import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { inquiriesApi } from '../../../api/adminApi';
import './InquiryView.css';

function InquiryView() {
  const { id } = useParams();
  const [inquiry, setInquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError('');
    inquiriesApi
      .getOne(id)
      .then((data) => setInquiry(data))
      .catch((err) => setError(err.userMessage || 'Failed to load inquiry'))
      .finally(() => setLoading(false));
  }, [id]);

  const formatDate = (str) => {
    if (!str) return '—';
    try {
      const d = new Date(str);
      return isNaN(d.getTime()) ? str : d.toLocaleDateString(undefined, { dateStyle: 'long' });
    } catch {
      return str;
    }
  };

  const field = (label, value) => (
    <div key={label} className="admin-inquiry-view-row">
      <dt>{label}</dt>
      <dd>{value ?? '—'}</dd>
    </div>
  );

  if (loading) {
    return <div className="admin-inquiry-view-loading">Loading inquiry…</div>;
  }

  if (error || !inquiry) {
    return (
      <div className="admin-inquiry-view">
        <div className="admin-inquiry-view-header">
          <Link to="/admin/inquiries" className="admin-inquiry-view-back">← Inquiries</Link>
        </div>
        <div className="admin-inquiry-view-error" role="alert">
          {error || 'Inquiry not found.'}
        </div>
      </div>
    );
  }

  const headerTitle =
    inquiry.subject ?? inquiry.topic ?? `Inquiry from ${inquiry.parent_name ?? inquiry.child_name ?? 'Unknown'}`;

  return (
    <div className="admin-inquiry-view">
      <div className="admin-inquiry-view-header">
        <Link to="/admin/inquiries" className="admin-inquiry-view-back">← Inquiries</Link>
        <h2>{headerTitle}</h2>
      </div>

      <div className="admin-inquiry-view-card">
        <dl className="admin-inquiry-view-details">
          {field('Parent', inquiry.parent_name ?? inquiry.name ?? inquiry.full_name ?? inquiry.sender_name)}
          {field(
            'Child',
            inquiry.child_name && inquiry.child_age != null
              ? `${inquiry.child_name} (age ${inquiry.child_age})`
              : inquiry.child_name || (inquiry.child_age != null ? `Age ${inquiry.child_age}` : null)
          )}
          {field('Email', inquiry.email ?? inquiry.sender_email)}
          {field('Phone', inquiry.phone ?? inquiry.phone_number)}
          <div className="admin-inquiry-view-row admin-inquiry-view-row--message">
            <dt>Message</dt>
            <dd className="admin-inquiry-view-message">
              {inquiry.message ?? inquiry.body ?? inquiry.content ?? '—'}
            </dd>
          </div>
          {field('Created', formatDate(inquiry.created_at ?? inquiry.createdAt ?? inquiry.date))}
        </dl>
      </div>
    </div>
  );
}

export default InquiryView;
